import React, { Component } from 'react';
import M from 'materialize-css';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { animateScroll as scroll } from 'react-scroll';
import {  
          PASO_ACTUAL_F1    as actualizaPasoActualF1Actions,         
          PASO_ACTUAL_F4    as actualizaPasoActualF4Actions,         
          
          DATOS_PORTALCOBRANZAS as actualizarPortalCobranzasActions,
          // EDITAR_ACTIVO as editarActivoAction,
          MOSTRAR_ACTIVO as mostrarActivoAction,
          ELIMINAR_ACTIVO as eliminarActivoActions,
          FLUJO_THANKUPAGE as flujoTypAction,
          CARGAR_IMAGEN_LOCAL as cargarImagenAction,
          ELIMINAR_IMAGEN_LOCAL as eliminarImagenAction,
          USUARIO as guardarUsuarioActions,
          LOGIN as loginActions,  
          obtenerParametros as obtenerParametrosActions, 
          obtenerDeclarante as obtenerDeclaranteAction,
          seleccionarPoliza as seleccionarPolizaAction,
          setItemPoliza as setItemPolizaAction,
          obtenerCoberturas as obtenerCoberturasAction
          } from '../../service/actions';
import Header from '../components/comunes/Header';
import Footer from '../components/comunes/Footer';
import Pasos from '../components/comunes/Pasos';
import Title from '../components/comunes/Title';
import { CONSTANTES } from '../utils/Constantes';
import ModalGenerico from '../components/comunes/ModalGenerico';
import Loading from '../components/comunes/Loading';
import { callService as callServiceAction, callServiceUsuarios as callServiceUsuariosAction  } from '../../service/commos/callService';
import { Auth } from 'aws-amplify';

const HOC = (Componente) => class extends Component {
  state = {
    isLoading: false,
    casoModal: '',
    mostrarModal: false,
    indexActivo: null,
    mensaje: '',
    indexBlankPage : '',
    indexSiniestro : '',
    indexAfiliacion : '',
    indexTransaccion : '',
    classMostrarDropdown: 'mb-display-none',
    usuario: '',
    showFooter: false
  } 

  componentWillMount(){

    let loginLS = this.getLocalStorage('login');
    let usuarioLS = this.getLocalStorage('usuario');
    
    
    if(usuarioLS){
        if(Object.values(usuarioLS).length > 0 && Object.values(this.props.usuario).length === 0){
          this.props.guardarUsuario(usuarioLS);
        }
    }    

    if(loginLS){
      this.props.actualizarLogin(loginLS);
      //this.setState({ detalleTitulo : this.mostrarInfoPaso() });
    }else{
      this.props.history.push({ pathname : CONSTANTES.RUTA.login });
    }    
  }

  componentDidMount(){
    M.AutoInit();
    this.scrollToTop();
    Auth.currentUserInfo().then(response => {
      // console.log(response);
      if (response && response.attributes != null){ // forzaron el cierre de sesión
        this.setState({
          usuario: response && response.attributes.email ? response.attributes.email : '', usernamecob: response.username
        });
      }
    });
  }

  onClickMenuMobile = () => {
    this.setState({
      classMostrarDropdown : 'mb-display-none' === this.state.classMostrarDropdown ? 'mostrarDropdown--show mb-display-flex' : 'mb-display-none',
    })
  }

  scrollToTop = () => {
    scroll.scrollToTop({
      duration: 1400,
      delay: 0,
      smooth: 'easeOutQuint'
    });
  }

 
  mostrarModal = (casoModal, indexActivo, mensaje) => {
    this.setState({
      casoModal,
      mensaje,
      mostrarModal: true,
      indexActivo      
    });
  }

  cerrarModal = () => {
    this.setState({ mostrarModal: false })
  }
  
  setLocalStorage = (key, value) => {
    localStorage.setItem(key, JSON.stringify(value));
  }

  getLocalStorage = (key) => {
    if(localStorage.hasOwnProperty(key)){
      const local = localStorage.getItem(key);
      return JSON.parse(local);
    }else{
      return {};
    }
    
  }

  removeLocalStorage = (key) => {
    localStorage.removeItem(key);
  }  
    
  cerrarSesion = async () => {
    this.setLocalStorage("mfaLogin", null);
    Auth.signOut();
  }

  mostrarLoading = () => {
    this.setState({isLoading: true });
  }

  ocultarLoading = () => {
    this.setState({isLoading: false });
  }

  irFlujo = (path) => {
    if (path){
      let flujo = path.replace('/','#');
      this.setLocalStorage('FLUJO', flujo);
      this.setLocalStorage('location-search', '?flujo='+flujo);      
      this.obtenerFlujoPortalCobranzas();
    }
  }
  t
  obtenerFlujoPortalCobranzas = () => {
    let location = this.getLocalStorage('location-search');
    let flujo =  location.replace('?flujo=','');
    this.setLocalStorage("FLUJO",flujo);
    if(localStorage.getItem('login') === "true"){
      this.props.history.push({ pathname : flujo.replace('#','/') });
    } else{
      this.props.history.push({ pathname : CONSTANTES.RUTA.login, search: location });   
    }
  }

  showSection = (section,valor) =>{
    this.setState({['show'+section]: valor})
  }

  render() {
    return (
      <>
        <Header 
          isLogin = {this.props.isLogin}
          usuario = {this.state.usuario}
          username = {this.state.usernamecob}
          onClick = {this.cerrarSesion}
          //irFlujo4 = {this.irFlujo4}                  
          //irFlujo1 = {this.irFlujo1}
          irFlujo = {this.irFlujo}                  
          classMostrarDropdown = {this.state.classMostrarDropdown}
          onClickMenuMobile = { this.onClickMenuMobile } />
        <div className="body">
              <Componente {...this} />
        </div>

          {this.state.isLoading ? <Loading /> : null } 
          <ModalGenerico               
              caso={this.state.casoModal}
              mostrar={this.state.mostrarModal}
              mensaje={this.state.mensaje}
              cerrarModal={ this.cerrarModal } 
          />

        <Footer mostrarModal={ this.mostrarModal }  pageLogin={false}  pageActivo = {this.state.showFooter} />
      </>
    );
  }
}



const mapStateToProps = store => {
  const pasos = store["pasosF"+JSON.parse(localStorage.getItem('FLUJO'))];
  return {
    flujo: store.flujo,
    rutas: store.rutas,    
    usuario: store.usuario,    
    isLogin: store.isLogin,  

    /** pasos */
    pasos       : pasos,
    totalPasos  : pasos ? store["pasosF"+JSON.parse(localStorage.getItem('FLUJO'))].totalPasos : 5,
    urlActual   : pasos ? store["pasosF"+JSON.parse(localStorage.getItem('FLUJO'))].urlActual : '',
    pasoActual  : pasos ? store["pasosF"+JSON.parse(localStorage.getItem('FLUJO'))].pasoActual : 0
    
  }
}

const mapDispatchToProps = dispatch => {
  return {
    callService : (method, nameService, request, action) => dispatch(callServiceAction(method, nameService, request, action)),
    callServiceUsuarios :  (method, nameService, request) => callServiceUsuariosAction(method, nameService, request),
    actualizarLogin : isLogin => dispatch(loginActions(isLogin)),        
    
    guardarUsuario: (custom, indLogin) => dispatch(guardarUsuarioActions(custom, indLogin)),    
    actualizaPasoActualF1     : (paso) => dispatch(actualizaPasoActualF1Actions(paso)),    
    actualizaPasoActualF4     : (paso) => dispatch(actualizaPasoActualF4Actions(paso))
  }
}

const ComposedHOCRedux = compose(connect(mapStateToProps, mapDispatchToProps), HOC); 


export default ComposedHOCRedux;
